<template>
  <div class="dashboard-employee-section">
    <div v-if="totalChild.state" class="dashboard-employee-container">
      <!-- Mobile tabs container -->
      <div class="dashboard-employee-tabs">
        <div class="employee-tabs-container">
          <div class="employee-tabs-content">
            <div
              v-for="data in tabsList"
              :key="data"
              @click="openTab(data.id)"
              class="employee-tab-content"
              :class="{'tab-content-active' : (tabActive == data.id)}"
            >
              {{ data.label }}
            </div>
          </div>
        </div>
      </div>

      <div class="dashboard-employee-content">
        <div class="dashboard-employee-outer">
          <div
            class="employee-outer-content"
            :style="(tabActive != 0) ? 'margin-left: calc((-100vw) *' + tabActive + ');' : 'margin-left: 0;'"
          >
            <!-- Container for mobile responsive -->
            <IndexCenter
              :tab-active="(tabActive == 0) ? true : false"
              :load-data="isLoading"
              :this-monthnow="thisMonthNow"
              :expired-contract="expiredContract ? expiredContract : []"
              :expired-contractfull="expiredContractFull ? expiredContractFull : []"
              :expiring-contract="expiringContract ? expiringContract : []"
              :expiring-contractfull="expiringContractFull ? expiringContractFull : []"
              :employee-retiring="['ROLE_ADMIN,', 'ROLE_ADMIN', 'ROLE_ADMIN_HRD', 'ROLE_ADMIN_HRD,', 'ROLE_MANAGEMENT'].includes(roles) ? employeeRetiring : []"
              :employee-retired="['ROLE_ADMIN,', 'ROLE_ADMIN', 'ROLE_ADMIN_HRD', 'ROLE_ADMIN_HRD,', 'ROLE_MANAGEMENT'].includes(roles) ? employeeRetired : []"
              @open-modal="openModal($event)"
              @open-detail="openDetail($event)"
              class="tab-mobile"
            />

            <IndexLeft
              :tab-active="(tabActive == 1) ? true : false"
              :load-data="isLoading"
              :training-waiting="trainingWaiting"
              :training-approve="trainingApprove"
              :training-reject="trainingReject"
              :training-waitingfull="trainingWaitingFull"
              :training-approvefull="trainingApproveFull"
              :training-rejectfull="trainingRejectFull"
              :punishment-payroll="punishmentPayroll"
              :punishment-perfomance="punishmentPerfomance"
              :punishment-position="punishmentPosition"
              :punishment-terminated="punishmentTerminated"
              :punishment-payrollfull="punishmentPayrollFull"
              :punishment-perfomancefull="punishmentPerfomanceFull"
              :punishment-positionfull="punishmentPositionFull"
              :punishment-terminatedfull="punishmentTerminatedFull"
              @open-modal="openModal($event)"
              @open-detail="openDetail($event)"
              class="tab-mobile"
            />

            <IndexRight
              :tab-active="(tabActive == 2) ? true : false"
              :load-data="isLoading"
              :this-monthnow="thisMonthNow"
              :expiring-decree="expiringCareer"
              :expiring-decreefull="expiringCareerFull"
              :expired-decree="expiredCareer"
              :expired-decreefull="expiredCareerFull"
              :expiring-doc="expiringDoc"
              :expiring-docfull="expiringDocFull"
              :expired-doc="expiredDoc"
              :expired-docfull="expiredDocFull"
              @open-modal="openModal($event)"
              @open-detail="openDetail($event)"
              class="tab-mobile"
            />

            <!-- Container for website responsive -->
            <IndexLeft
              :load-data="isLoading"
              :this-monthnow="thisMonthNow"
              :training-waiting="trainingWaiting"
              :training-approve="trainingApprove"
              :training-reject="trainingReject"
              :training-waitingfull="trainingWaitingFull"
              :training-approvefull="trainingApproveFull"
              :training-rejectfull="trainingRejectFull"
              :punishment-payroll="punishmentPayroll"
              :punishment-perfomance="punishmentPerfomance"
              :punishment-position="punishmentPosition"
              :punishment-terminated="punishmentTerminated"
              :punishment-payrollfull="punishmentPayrollFull"
              :punishment-perfomancefull="punishmentPerfomanceFull"
              :punishment-positionfull="punishmentPositionFull"
              :punishment-terminatedfull="punishmentTerminatedFull"
              @open-modal="openModal($event)"
              @open-detail="openDetail($event)"
              class="tab-desktop"
            />

            <IndexCenter
              :load-data="isLoading"
              :this-monthnow="thisMonthNow"
              :expired-contract="expiredContract ? expiredContract : []"
              :expired-contractfull="expiredContractFull ? expiredContractFull : []"
              :expiring-contract="expiringContract ? expiringContract : []"
              :expiring-contractfull="expiringContractFull ? expiringContractFull : []"
              :employee-retiring="['ROLE_ADMIN,', 'ROLE_ADMIN', 'ROLE_ADMIN_HRD', 'ROLE_ADMIN_HRD,', 'ROLE_MANAGEMENT'].includes(roles) ? employeeRetiring : []"
              :employee-retired="['ROLE_ADMIN,', 'ROLE_ADMIN', 'ROLE_ADMIN_HRD', 'ROLE_ADMIN_HRD,', 'ROLE_MANAGEMENT'].includes(roles) ? employeeRetired : []"
              @open-modal="openModal($event)"
              @open-detail="openDetail($event)"
              class="tab-desktop"
            />

            <IndexRight
              :load-data="isLoading"
              :this-monthnow="thisMonthNow"
              :expiring-decree="expiringCareer"
              :expiring-decreefull="expiringCareerFull"
              :expired-decree="expiredCareer"
              :expired-decreefull="expiredCareerFull"
              :expiring-doc="expiringDoc"
              :expiring-docfull="expiringDocFull"
              :expired-doc="expiredDoc"
              :expired-docfull="expiredDocFull"
              @open-modal="openModal($event)"
              @open-detail="openDetail($event)"
              class="tab-desktop"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-else class="dashboard-employee-container-blank">
      <div class="inner-blank">
        <p>No child data</p>
      </div>
    </div>
  </div>

  <!-- Detail modal -> list -->
  <vue-final-modal
    v-for="(index, value) in modalDetail" :key="value"
    v-model="modalDetail[value]"
    classes="base-modal"
    :ssr="true"
    content-class="base-modal-dashboard-employee bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false" transition="vfm" overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false" drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>
        {{
          (value == 'trainingWaiting') ? 'Training Details' :
          (value == 'trainingApprove') ? 'Training Details' :
          (value == 'trainingReject') ? 'Training Details' :
          (value == 'expiringDoc') ? 'Expiring Document Details' :
          (value == 'expiredDoc') ? 'Expired Document Details' :
          (value == 'expiringDecree') ? 'Expiring Decree Details' :
          (value == 'expiredDecree') ? 'Expired Decree Details' :
          (value == 'expiringLeave') ? 'Expiring Leave Details' :
          (value == 'expiredLeave') ? 'Expired Leave Details' :
          (value == 'expiringContract') ? 'Expiring Contract Details' :
          (value == 'expiredContract') ? 'Expired Contract Details' :
          (value == 'punishmentPayroll') ? 'Consider in Payroll Details' :
          (value == 'punishmentPerfomance') ? 'Consider in Perfomance Details' :
          (value == 'punishmentPosition') ? 'Relate to Position Details' :
          (value == 'punishmentTerminated') ? 'Is Terminated Details' : ''
        }}
      </h1>
      <jb-button class="btn-close-modal" :icon="mdiClose" @click="openModal({type: value, status: false})"/>
    </div>

    <!-- Modal Content -->
    <div class="modal-content-dashboard-employee">
      <div v-if="(value == 'attendance')" class="detail-attendance-content">
        <div v-if="objectDetail" class="attendance-content">
          <div v-for="data in objectDetail" :key="data" class="month-container">
            <div class="month-header">
              <p>{{ data.month_name + ' ' + data.year }}</p>
            </div>

            <div v-if="data.month_presence" class="month-outer">
              <div v-for="(child, index) in data.month_presence" :key="child" v-show="!['total_libur', 'total_present', 'total_tardy'].includes(index)" class="month-list">
                <div class="month-inner" :class="{'month-inner-full-red' : child[1] == 'Libur'}">
                  <div class="month-number">
                    <p v-if="child[1]" :class="{'text-red' : child[1].slice(8, child[1].length) == 'late'}">{{ index }}</p>
                    <p v-else>{{ index }}</p>
                  </div>

                  <div class="month-time">
                    <p v-if="(child[1] != 'Libur') && (child[1] || child[2])" :class="{'text-red' : child[1].slice(8, child[1].length) == 'late'}">{{ child[1].slice(0, 5) + ' - ' + child[2].slice(0, 5) + ' (' + child[1].slice(8, child[1].length) + ')' }}</p>
                    <p v-else>{{ child[1] }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div v-else-if="(value == 'leaveBalance')" class="detail-remaining-content"> -->
      <div v-else class="detail-remaining-content">
        <div v-if="objectDetail" class="detail-tree">
          <div v-if="objectDetail.length == 0" class="detail-tree-no">
            <p>No data!</p>
          </div>

          <div v-else v-for="parent in objectDetail" :key="parent" class="detail-tree-period">
            <div class="period-header">
              {{ parent.period ? parent.period : parent.year ? parent.year : '' }}
            </div>

            <div class="detail-tree-inherit">
              <div v-for="data in parent.list ? parent.list : parent.month ? parent.month : 0" :key="data" class="parent-tree-container">
                <div class="parent-tree-content">
                  <p v-if="data.sisa_cuti"><b>{{ data.leave_name }}</b> | Remaining leave balance: <b>{{ data.sisa_cuti }}</b></p>
                  <p v-else><b>{{ data.month_name }}</b></p>
                </div>

                <div
                  v-for="child in data.history_cuti ? data.history_cuti : data.data ? data.data : 0"
                  :key="child"
                  @click="
                    ['leaveWaiting', 'leaveApprove', 'leaveReject'].includes(value) ? openDetail(child, 'leave')
                    : ['trainingWaiting', 'trainingApprove', 'trainingReject'].includes(value) ? openDetail(child, 'training')
                    : ['expiringDecree', 'expiredDecree'].includes(value) ? openDetail(child, 'decree')
                    : ['expiringDoc', 'expiredDoc'].includes(value) ? openDetail(child, 'document')
                    : ['expiringContract', 'expiredContract'].includes(value) ? openDetail(child, 'contract')
                    : ['punishmentPayroll', 'punishmentPerfomance', 'punishmentPosition', 'punishmentTerminated'].includes(value) ? openDetail(child, 'punishment')
                    : null"
                  class="child-tree-container"
                  :class="{
                    'child-tree-yellow': ((child.state == 'Waiting for Approval') || (child.forState == 'Expiring') || (child.forState == 'yellow')),
                    'child-tree-green': ((child.state == 'Approved')) || (child.forState == 'green') || ((child.sign_type == '1') && data.history_cuti),
                    'child-tree-red': ((child.state == 'Rejected')) || (child.forState == 'Expired') || (child.forState == 'red') || ((child.sign_type == '-1') && data.history_cuti)
                  }"
                >
                  <p v-if="child.forValue1" class="list-name"><b v-html="child.forValue1" /></p>
                  <p v-else-if="data.history_cuti" class="list-name"><b v-html="formatDate('date', child.leave_date)" /></p>
                  <p v-else-if="!data.history_cuti" class="list-name"><b v-html="child.organizer ? (child.organizer + ' (' + child.venue + ')') : child.transaction_no ? child.transaction_no : child.title ? child.title : ''" /></p>

                  <p v-if="child.forValue4" class="list-subject" v-html="child.forValue4" />

                  <p v-if="child.forValue2" class="list-info" v-html="child.forValue2" />
                  <p v-else-if="data.history_cuti" class="list-info" v-html="child.transaction" />
                  <p v-else-if="!data.history_cuti" class="list-info" v-html="child.info ? child.info : child.name ? child.name : ''" />

                  <p v-if="child.forValue3" class="list-date" v-html="child.forValue3" />
                  <p v-else-if="!data.history_cuti" class="list-date" v-html="child.start_date ? formatDate('event', child.start_date, child.end_date) : child.created_at ? formatDate('date', child.created_at) : child.createdat ? formatDate('date', child.createdat) : ''" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </vue-final-modal>

  <!-- Detail modal -> transaction -->
  <vue-final-modal
    v-model="detailModal"
    classes="base-modal"
    :ssr="true"
    :content-class="{
      'relative h-5/6 flex flex-col mx-4 md:mx-0 pb-4 w-11/12 md:w-10/12 lg:w-10/12' : ['decree', 'document', 'contract'].includes(modalType),
      'relative h-5/6 flex flex-col mx-4 md:mx-0 pb-4 w-11/12 md:w-2/3 lg:w-1/2' : ['training', 'leave', 'punishment'].includes(modalType)
    }"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false" transition="vfm" overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false" drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <div class="modal-head">
      <h1 v-if="modalType == 'training'">{{ $t("employeetraining.detail") }}</h1>
      <h1 v-else-if="modalType == 'leave'">Detail Transaction</h1>
      <h1 v-else-if="modalType == 'decree'">Detail Decree</h1>
      <h1 v-else-if="modalType == 'document'">Detail Document</h1>
      <h1 v-else-if="modalType == 'contract'">Detail Contract</h1>
      <h1 v-else-if="modalType == 'punishment'">Detail Punishment</h1>
      <jb-button class="btn-close-modal" :icon="mdiClose" @click="openDetail()" />
    </div>

    <div v-if="detailData" class="modal-content detail-content" style="background-color: white;">
      <EmployeeTrainingDetail v-if="modalType == 'training'" :prop-employee-training="detailData" @close-modal="openDetail()" @refresh-list="refreshData()" />

      <HrreqleaveDetail v-else-if="modalType == 'leave'" :prop-class="detailData" @close-modal="openDetail()" @refresh-list="refreshData()" />

      <EmployeeDetail v-else-if="['decree', 'document', 'contract'].includes(modalType)" :prop-class="detailData" :prop-id="detailData.employee_id" :is-decree="(modalType == 'decree') ? true : false" :is-contract="(modalType == 'contract') ? true : false" :is-document="(modalType == 'document') ? true : false" @close-modal="openDetail()" />

      <PunishmentTransactionDetail v-else-if="modalType == 'punishment'" :prop-class="detailData" @close-modal="openDetail()"/>
    </div>
  </vue-final-modal>
</template>

<script>
  /* eslint-disable */
  import { defineComponent, ref, reactive, onBeforeMount, onMounted, watch, watchEffect, computed } from "vue"
  import { useRouter, useRoute } from "vue-router"
  import { useI18n } from 'vue-i18n'
  import { useStore } from 'vuex'
  import axios from 'axios'
  import dayjs from 'dayjs'
  import { mdiClose } from '@mdi/js'

  import JbButton from '@/components/JbButton'
  import IndexCenter from "./referensi/employee/EmployeeDashboard/IndexCenter.vue"
  import IndexLeft from "./referensi/employee/EmployeeDashboard/IndexLeft.vue"
  import IndexRight from "./referensi/employee/EmployeeDashboard/IndexRight.vue"
  import HrreqleaveDetail from '@/views/humanresource/hrreqleave/Detail'
  import EmployeeTrainingDetail from "@/views/humanresource/employeetraining/EmployeeTrainingDetail"
  import EmployeeDetail from '@/views/referensi/employee/EmployeeDetail'
  import PunishmentTransactionDetail from "@/views/humanresource/punishmentTransaction/PunishmentTransactionDetail"

  export default {
    components: {
      JbButton,
      IndexCenter,
      IndexLeft,
      IndexRight,
      HrreqleaveDetail,
      EmployeeTrainingDetail,
      EmployeeDetail,
      PunishmentTransactionDetail
    },

    setup(props, { emit }) {
      const { t, locale } = useI18n()
      const router = useRouter()
      const route = useRoute()
      const store = useStore()
      const isLoading = ref(false)
      const employeeId = computed(() => localStorage.getItem('employee_id'))
      const branchId = computed(() => localStorage.getItem('branch_id'))
      const userId = computed(() => localStorage.getItem('user_id'))
      const usernameLogin = computed(() => localStorage.getItem('username'))
      const roles = computed(() => localStorage.getItem('roles'))


      const tabsList = ref([
        {
          id: 0,
          label: "Information"
        },
        {
          id: 1,
          label: "Document State"
        },
        {
          id: 2,
          label: "Expired Documents"
        }
      ])
      const tabActive = ref(0)
      const openTab = (id) => {
        tabActive.value = id
      }


      const monthsId = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]
      const monthsEn = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      const shortMonthsId = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"]
      const shortMonthsEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Agu", "Sep", "Oct", "Nov", "Dec"]
      const daysId = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
      const daysEn = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

      function formatDate(type, date, dateSec) {
        const start = new Date(date)
        const end = new Date(dateSec)

        const day = start.getDate()
        const month = start.getMonth()
        const year = start.getFullYear()
        const dayOfWeek = start.getDay()

        const months = locale.value == 'id' ? monthsId : monthsEn
        const monthsShort = locale.value == 'id' ? shortMonthsId : shortMonthsEn
        const days = locale.value == 'id' ? daysId : daysEn
        // const daysShort = locale.value == 'id' ? shortDaysId : shortDaysEn

        if(type == 'dateTime') {
          return `${daysEn[dayOfWeek]}, ${day} ${monthsEn[month]} ${year}`
        }
        else if(type == 'monthYear') {
          return `${monthsEn[month]} ${year}`
        }
        else if(type == 'month') {
          return `${monthsEn[month]}`
        }
        else if(type == 'monthNum') {
          return `${month}`
        }
        else if(type == 'date') {
          return `${day} ${monthsEn[month]} ${year}`
        }
        else if(type == 'day') {
          return `${day}`
        }
        else if (type == 'event') {
          const endDay = end.getDate()
          const endMonth = end.getMonth()
          const endYear = end.getFullYear()

          const startTime = start.toLocaleTimeString('id-ID', {
            hour: '2-digit', minute: '2-digit', hour12: false
          }).replace(":", ".")

          const endTime = end.toLocaleTimeString('id-ID', {
            hour: '2-digit', minute: '2-digit', hour12: false
          }).replace(":", ".")

          const isZeroTime = startTime === "00.00" && endTime === "00.00"
          const timeRange = isZeroTime ? "" : ` (${startTime} - ${endTime})`

          if (day === endDay && month === endMonth && year === endYear) {
            return `${days[dayOfWeek]}, ${day} ${monthsShort[month]} ${year}${timeRange}`
          } else if (month === endMonth && year === endYear) {
            return `${day} - ${endDay} ${monthsShort[month]} ${year}${timeRange}`
          } else {
            return `${day} ${monthsShort[month]} - ${endDay} ${monthsShort[endMonth]} ${endYear}${timeRange}`
          }
        }
      }


      function formatList(data) {
        const monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ]
        const groupedData = {}

        data.forEach(item => {
          const dateObj = new Date(item.forFormatDate)
          const year = dateObj.getFullYear().toString()
          const monthIndex = dateObj.getMonth()
          const monthName = monthNames[monthIndex]

          if (!groupedData[year]) {
            groupedData[year] = {}
          }


          if (!groupedData[year][monthName]) {
            groupedData[year][monthName] = {
              data: [],
              index: monthIndex
            }
          }

          groupedData[year][monthName].data.push(item)
        })

        const result = Object.entries(groupedData)
        .sort((a, b) => b[0] - a[0])
        .map(([year, months]) => {
          const sortedMonths = Object.entries(months)
            .sort((a, b) => b[1].index - a[1].index)
            .map(([month_name, { data }]) => ({
              month_name,
              data
            }))

          return {
            year,
            month: sortedMonths
          }
        })

        return result
      }


      const modalDetail = reactive({
        attendance: false,
        leaveBalance: false,
        latestUpdate: false,
        leaveWaiting: false,
        leaveApprove: false,
        leaveReject: false,
        trainingWaiting: false,
        trainingApprove: false,
        trainingReject: false,
        expiringDoc: false,
        expiredDoc: false,
        expiringDecree: false,
        expiredDecree: false,
        expiringLeave: false,
        expiredLeave: false,
        expiringContract: false,
        expiredContract: false,
        punishmentPayroll: false,
        punishmentPerfomance: false,
        punishmentPosition: false,
        punishmentTerminated: false
      })
      const objectDetail = ref({})
      const openModal = (event) => {
        console.log("cek modal", event)
        modalDetail[event.type] = event.status ? event.status : false
        objectDetail.value = (event.data ? event.data : {})

        // console.log("cek object", event.type, modalDetail[event.type], objectDetail.value)
      }


      const trainingWaiting = ref([])
      const trainingWaitingFull = ref([])
      const trainingApprove = ref([])
      const trainingApproveFull = ref([])
      const trainingReject = ref([])
      const trainingRejectFull = ref([])

      const expiringDoc = ref([])
      const expiredDoc = ref([])
      const expiringDocFull = ref([])
      const expiredDocFull = ref([])

      const expiringLeave = ref([])
      const expiredLeave = ref([])
      const expiringLeaveFull = ref([])
      const expiredLeaveFull = ref([])

      const expiringContract = ref([])
      const expiredContract = ref([])
      const expiringContractFull = ref([])
      const expiredContractFull = ref([])

      const expiringCareer = ref([])
      const expiredCareer = ref([])
      const expiringCareerFull = ref([])
      const expiredCareerFull = ref([])

      const employeeRetiring = ref([])
      const employeeRetired = ref([])

      const punishmentPayroll = ref([])
      const punishmentPayrollFull = ref([])
      const punishmentPerfomance = ref([])
      const punishmentPerfomanceFull = ref([])
      const punishmentPosition = ref([])
      const punishmentPositionFull = ref([])
      const punishmentTerminated = ref([])
      const punishmentTerminatedFull = ref([])

      const getData = async () => {
        isLoading.value = true

        const thisDate = new Date()
        let thisYear = thisDate.getFullYear()
        let thisMonth = ('0' + (thisDate.getMonth() + 1)).slice(-2)

        const headers = {'Content-Encoding': 'gzip'}

        const paramsLeave = {
          username: usernameLogin.value,
          is_all: true,
          is_personal: 0,
          year: thisYear,
          month: thisMonth
        }

        const paramsLeaveFull = {
          username: usernameLogin.value,
          is_all: true,
          is_personal: 0,
          year: null,
          month: null
        }

        const paramsExpire = {
          user_id: userId.value,
          is_personal: 0,
          year: thisYear,
          month: thisMonth
        }

        const paramsExpireFull = {
          user_id: userId.value,
          is_personal: 0,
          year: null,
          month: null
        }

        const paramsPunishment = {
          user_id: userId.value,
          branch_id: branchId.value,
          is_personal: 0,
          year: thisYear,
          month: thisMonth
        }

        const paramsPunishmentFull = {
          user_id: userId.value,
          branch_id: branchId.value,
          is_personal: 0,
          year: null,
          month: null
        }

        try {
          const [response1, response2, response3, response4, response5, response6, response7] = await Promise.all([
            axios.get("get-leave-notif", { headers, params: paramsLeave }),
            axios.get("get-leave-notif", { headers, params: paramsLeaveFull }),
            axios.get("get-list-expired-employee", { headers, params: paramsExpire }),
            axios.get("get-list-expired-employee", { headers, params: paramsExpireFull }),
            axios.get("get-employee-retirement", { headers }),
            axios.get("dashboard-punishment", { headers, params: paramsPunishment }),
            axios.get("dashboard-punishment", { headers, params: paramsPunishmentFull })
          ])

          // ----- Data training this month (waiting, approved, rejected) -----
          if(response1.data.dataTraining) {
            const prevData = response1.data.dataTraining
            // console.log("cek prev training", prevData)

            if(prevData) {
              const formatData = []

              for (const [index, value] of Object.entries(prevData)) {
                const formatLoop = {
                  id: value.id,
                  value1: value.employee_name,
                  value2: value.name,
                  value3: formatDate('event', value.start_date, value.end_date),
                  value4: value.organizer + ' (' + value.venue + ')',
                  value5: (value.state == 'Approved') ? ('Approved by<br>' + value.updated_by) : (value.state == 'Rejected') ? ('Rejected by<br>' + value.updated_by) : null,
                  state: value.state
                }

                formatData.push(formatLoop)
              }

              // console.log("cek training formated", formatData)

              trainingWaiting.value = formatData.filter(item => item.state == "Waiting for Approval").slice(0, 10)
              trainingApprove.value = formatData.filter(item => item.state == "Approved").slice(0, 10)
              trainingReject.value = formatData.filter(item => item.state == "Rejected").slice(0, 10)

              // console.log("cek training waiting", trainingWaiting.value)
              // console.log("cek training approve", trainingApprove.value)
              // console.log("cek training reject", trainingReject.value)
            }
          }

          // ----- Data training all month & year (waiting, approved, rejected) -----
          if(response2.data.dataTraining) {
            const prevData = response2.data.dataTraining
            // console.log("cek prev training all", prevData)

            if(prevData) {
              const formatData = []

              for (const [index, value] of Object.entries(prevData)) {
                const formatLoop = value
                formatLoop['forId'] = value.id
                formatLoop['forFormatDate'] = value.start_date
                // formatLoop['forValue1'] = value.employee_name + ' (' + value.venue + ')'
                formatLoop['forValue1'] = value.employee_name
                formatLoop['forValue2'] = value.name
                formatLoop['forValue3'] = formatDate('event', value.start_date, value.end_date)
                formatLoop['forValue4'] = value.organizer + ' (' + value.venue + ')',
                formatLoop['forState'] = value.state

                formatData.push(formatLoop)
              }

              // console.log("cek training all formated", formatData)

              trainingWaitingFull.value = formatData.filter(item => item.state == "Waiting for Approval")
              trainingApproveFull.value = formatData.filter(item => item.state == "Approved")
              trainingRejectFull.value = formatData.filter(item => item.state == "Rejected")

              // console.log("cek training waiting full", trainingWaitingFull.value)
              // console.log("cek training approve full", trainingApproveFull.value)
              // console.log("cek training reject full", trainingRejectFull.value)
            }
          }

          // ----- Data is expiring & expired this month (contract, decree, document) -----
          if(response3.data) {
            const basicData = response3.data
            const prevExgContract = basicData.dataContractExpiring
            const prevExdContract = basicData.dataContractExpired
            const prevExgDecree = basicData.dataCareerPathExpiring
            const prevExdDecree = basicData.dataCareerPathExpired
            const prevExgDocument = basicData.dataTrainingDocExpiring
            const prevExdDocument = basicData.dataTrainingDocExpired

            // Expiring contract
            if(prevExgContract) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExgContract)) {
                const formatLoop = {
                  id: value.employee_id,
                  value1: value.employee_name,
                  value2: value.info,
                  value3: formatDate('date', value.transaction_no),
                  state: null
                }

                formatData.push(formatLoop)
              }

              expiringContract.value = formatData.slice(0, 10)
            }

            // Expired contract
            if(prevExdContract) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExdContract)) {
                const formatLoop = {
                  id: value.employee_id,
                  value1: value.employee_name,
                  value2: value.info,
                  value3: formatDate('date', value.transaction_no),
                  state: null
                }

                formatData.push(formatLoop)
              }

              expiredContract.value = formatData.slice(0, 10)
              // console.log("cek expired contract", expiredContract.value)
            }

            // Expiring decree
            if(prevExgDecree) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExgDecree)) {
                const formatLoop = {
                  id: value.employee_id,
                  value1: value.employee_name,
                  value2: value.info,
                  value3: formatDate('date', value.transaction_no),
                  state: null
                }

                formatData.push(formatLoop)
              }

              expiringCareer.value = formatData.slice(0, 10)
            }

            // Expired decree
            if(prevExdDecree) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExdDecree)) {
                const formatLoop = {
                  id: value.employee_id,
                  value1: value.employee_name,
                  value2: value.info,
                  value3: formatDate('date', value.transaction_no),
                  state: null
                }

                formatData.push(formatLoop)
              }

              expiredCareer.value = formatData.slice(0, 10)
              // console.log("cek expired decree", expiredCareer.value)
            }

            // Expiring document
            if(prevExgDocument) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExgDocument)) {
                const formatLoop = {
                  id: value.employee_id,
                  value1: value.employee_name,
                  value2: value.info,
                  value3: formatDate('date', value.transaction_no),
                  state: null
                }

                formatData.push(formatLoop)
              }

              expiringDoc.value = formatData.slice(0, 10)
              // console.log("cek expiring document", expiringDoc.value)
            }

            // Expired document
            if(prevExdDocument) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExdDocument)) {
                const formatLoop = {
                  id: value.employee_id,
                  value1: value.employee_name,
                  value2: value.info,
                  value3: formatDate('date', value.transaction_no),
                  state: null
                }

                formatData.push(formatLoop)
              }

              expiredDoc.value = formatData.slice(0, 10)
              // console.log("cek expired document", expiredDoc.value)
            }
          }

          // ----- Data is expiring & expired all month & year (contract, decree, document) -----
          if(response4.data) {
            const basicData = response4.data
            const prevExgContract = basicData.dataContractExpiring
            const prevExdContract = basicData.dataContractExpired
            const prevExgDecree = basicData.dataCareerPathExpiring
            const prevExdDecree = basicData.dataCareerPathExpired
            const prevExgDocument = basicData.dataTrainingDocExpiring
            const prevExdDocument = basicData.dataTrainingDocExpired

            // console.log("cek all", basicData)

            // console.log("cek contract expiring prev", prevExgContract)
            // Expiring contract
            if(prevExgContract) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExgContract)) {
                // const formatLoop = {
                //   id: null,
                //   value1: value.employee_name,
                //   value2: value.info,
                //   value3: formatDate('date', value.transaction_no),
                //   state: null
                // }

                const formatLoop = value
                formatLoop['forId'] = null
                formatLoop['forFormatDate'] = value.transaction_no
                formatLoop['forValue1'] = value.employee_name
                formatLoop['forValue2'] = value.info
                formatLoop['forValue3'] =  formatDate('date', value.transaction_no)
                formatLoop['forState'] = 'Expiring'

                formatData.push(formatLoop)
              }

              expiringContractFull.value = formatData
              // console.log("cek expiring contract", expiringContractFull.value)
            }

            // console.log("cek contract expired prev", prevExdContract)
            // Expired contract
            if(prevExdContract) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExdContract)) {
                // const formatLoop = {
                //   id: null,
                //   value1: value.employee_name,
                //   value2: value.info,
                //   value3: formatDate('date', value.transaction_no),
                //   state: null
                // }

                const formatLoop = value
                formatLoop['forId'] = null
                formatLoop['forFormatDate'] = value.transaction_no
                formatLoop['forValue1'] = value.employee_name
                formatLoop['forValue2'] = value.info
                formatLoop['forValue3'] =  formatDate('date', value.transaction_no)
                formatLoop['forState'] = 'Expired'

                formatData.push(formatLoop)
              }

              expiredContractFull.value = formatData
              // console.log("cek expired contract", expiredContractFull.value)
            }

            // console.log("cek decree expiring prev", prevExgDecree)
            // Expiring decree
            if(prevExgDecree) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExgDecree)) {
                // const formatLoop = {
                //   id: null,
                //   value1: value.employee_name,
                //   value2: value.info,
                //   value3: formatDate('date', value.transaction_no),
                //   state: null
                // }

                const formatLoop = value
                formatLoop['forId'] = null
                formatLoop['forFormatDate'] = value.transaction_no
                formatLoop['forValue1'] = value.employee_name
                formatLoop['forValue2'] = value.info
                formatLoop['forValue3'] =  formatDate('date', value.transaction_no)
                formatLoop['forState'] = 'Expiring'

                formatData.push(formatLoop)
              }

              expiringCareerFull.value = formatData
              // console.log("cek expiring decree", expiringCareerFull.value)
            }

            // console.log("cek decree expired prev", prevExdDecree)
            // Expired decree
            if(prevExdDecree) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExdDecree)) {
                // const formatLoop = {
                //   id: null,
                //   value1: value.employee_name,
                //   value2: value.info,
                //   value3: formatDate('date', value.transaction_no),
                //   state: null
                // }

                const formatLoop = value
                formatLoop['forId'] = null
                formatLoop['forFormatDate'] = value.transaction_no
                formatLoop['forValue1'] = value.employee_name
                formatLoop['forValue2'] = value.info
                formatLoop['forValue3'] =  formatDate('date', value.transaction_no)
                formatLoop['forState'] = 'Expired'

                formatData.push(formatLoop)
              }

              expiredCareerFull.value = formatData
              // console.log("cek expired decree", expiredCareerFull.value)
            }

            // console.log("cek document expiring prev", prevExgDocument)
            // Expiring document
            if(prevExgDocument) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExgDocument)) {
                // const formatLoop = {
                //   id: null,
                //   value1: value.employee_name,
                //   value2: value.info,
                //   value3: formatDate('date', value.transaction_no),
                //   state: null
                // }

                const formatLoop = value
                formatLoop['forId'] = null
                formatLoop['forFormatDate'] = value.transaction_no
                formatLoop['forValue1'] = value.employee_name
                formatLoop['forValue2'] = value.info
                formatLoop['forValue3'] =  formatDate('date', value.transaction_no)
                formatLoop['forState'] = 'Expiring'

                formatData.push(formatLoop)
              }

              expiringDocFull.value = formatData
              // console.log("cek expiring document", expiringDocFull.value)
            }

            // console.log("cek document expired prev", prevExdDocument)
            // Expired document
            if(prevExdDocument) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExdDocument)) {
                // const formatLoop = {
                //   id: null,
                //   value1: value.employee_name,
                //   value2: value.info,
                //   value3: formatDate('date', value.transaction_no),
                //   state: null
                // }

                const formatLoop = value
                formatLoop['forId'] = null
                formatLoop['forFormatDate'] = value.transaction_no
                formatLoop['forValue1'] = value.employee_name
                formatLoop['forValue2'] = value.info
                formatLoop['forValue3'] =  formatDate('date', value.transaction_no)
                formatLoop['forState'] = 'Expired'

                formatData.push(formatLoop)
              }

              expiredDocFull.value = formatData
              // console.log("cek expired document", expiredDocFull.value)
            }
          }

          if(response5.data.data) {
            const prevData = response5.data.data
            // console.log("cek retire", prevData)

            if(prevData) {
              const formatData = []

              for (const [index, value] of Object.entries(prevData)) {
                var periodYear = ((value.work_period < 2) ? (value.work_period + ' year') : (value.work_period + ' years'))
                const formatLoop = {
                  id: value.id,
                  title: value.employee_name + ' (' + value.ein +')',
                  value: "<table><tr><td>Work Unit</td><td>:</td><td>" + value.work_unit + "</td></tr><tr><td>Effective Date</td><td>:</td><td>" + formatDate('date', value.start_working) + "</td></tr><tr><td>Working Period</td><td>:</td><td>" + periodYear  + "</td></tr><tr><td>Retirement Year</td><td>:</td><td>" + value.retirement_year + "</td></tr><tr><td>Retirement Age</td><td>:</td><td>" + value.retirement_age + " years old</td></tr></table>",
                  filterYear: value.retirement_year
                }

                formatData.push(formatLoop)
              }

              employeeRetiring.value = formatData.filter(item => item.filterYear >= thisYear)
              employeeRetired.value = formatData.filter(item => item.filterYear < thisYear)
              // console.log("cek employee retiring", employeeRetiring.value, thisYear)
              // console.log("cek employee retired", employeeRetired.value, thisYear)
            }
          }

          // ----- Data punishment this month -----
          if(response6.data.data) {
            const prevData = response6.data.data
            // console.log("cek punishment", prevData)

            if(prevData) {
              for (const [index, value] of Object.entries(prevData)) {
                if(value.id == 'consider_in_payroll') {
                  const formatData = []

                  if(value.list) {
                    for (const [list, child] of Object.entries(value.list)) {
                      const formatLoop = {
                        id: child.id,
                        value1: child.number,
                        value2: child.punishment_description,
                        value3: formatDate('date', child.transaction_date),
                        value4: child.employee_name,
                        value5: null,
                        state: null
                      }
                      formatData.push(formatLoop)
                    }
                  }

                  punishmentPayroll.value = formatData
                  // console.log("cek loop child payroll", punishmentPayroll.value)
                }
                else if(value.id == 'consider_in_performance') {
                  const formatData = []

                   if(value.list) {
                    for (const [list, child] of Object.entries(value.list)) {
                      const formatLoop = {
                        id: child.id,
                        value1: child.number,
                        value2: child.punishment_description,
                        value3: formatDate('date', child.transaction_date),
                        value4: child.employee_name,
                        value5: null,
                        state: null
                      }
                      formatData.push(formatLoop)
                    }
                  }

                  punishmentPerfomance.value = formatData
                  // console.log("cek loop child perfomance", punishmentPerfomance.value)
                }
                else if(value.id == 'relate_to_position') {
                  const formatData = []

                   if(value.list) {
                    for (const [list, child] of Object.entries(value.list)) {
                      const formatLoop = {
                        id: child.id,
                        value1: child.number,
                        value2: child.punishment_description,
                        value3: formatDate('date', child.transaction_date),
                        value4: child.employee_name,
                        value5: null,
                        state: null
                      }
                      formatData.push(formatLoop)
                    }
                  }

                  punishmentPosition.value = formatData
                  // console.log("cek loop child position", punishmentPosition.value)
                }
                else if(value.id == 'is_terminated') {
                  const formatData = []

                   if(value.list) {
                    for (const [list, child] of Object.entries(value.list)) {
                      const formatLoop = {
                        id: child.id,
                        value1: child.number,
                        value2: child.punishment_description,
                        value3: formatDate('date', child.transaction_date),
                        value4: child.employee_name,
                        value5: null,
                        state: null
                      }
                      formatData.push(formatLoop)
                    }
                  }

                  punishmentTerminated.value = formatData
                  // console.log("cek loop child terminated", punishmentTerminated.value)
                }
              }
            }
          }

          // ----- Data punishment all month & year -----
          if(response7.data.data) {
            const prevData = response7.data.data
            // console.log("cek punishment all", prevData)

            if(prevData) {
              for (const [index, value] of Object.entries(prevData)) {
                if(value.id == 'consider_in_payroll') {
                  const formatData = []

                  if(value.list) {
                    for (const [list, child] of Object.entries(value.list)) {
                      const formatLoop = child
                      formatLoop['forId'] = child.id
                      formatLoop['forFormatDate'] = child.transaction_date
                      formatLoop['forValue1'] = child.number
                      formatLoop['forValue2'] = `<table style="width: 100%;"><tr><td style="width: 100px; font-weight: 500;">Punishment</td><td style="width: 10px;">:</td><td style="width: calc(100% - 110px);">${ child.punishment_description }</td></tr><tr><td style="width: 100px; font-weight: 500;">Violation</td><td style="width: 10px;">:</td><td style="width: calc(100% - 110px);">${ child.violation_description }</td></tr></table>`
                      formatLoop['forValue3'] = formatDate('date', child.transaction_date)
                      formatLoop['forValue4'] = child.employee_name,
                      formatLoop['forState'] = 'yellow'
                      formatData.push(formatLoop)
                    }
                  }

                  punishmentPayrollFull.value = formatData
                  // console.log("cek loop child payroll full", punishmentPayrollFull.value)
                }
                else if(value.id == 'consider_in_performance') {
                  const formatData = []

                   if(value.list) {
                    for (const [list, child] of Object.entries(value.list)) {
                      const formatLoop = child
                      formatLoop['forId'] = child.id
                      formatLoop['forFormatDate'] = child.transaction_date
                      formatLoop['forValue1'] = child.number
                      formatLoop['forValue2'] = `<table style="width: 100%;"><tr><td style="width: 100px; font-weight: 500;">Punishment</td><td style="width: 10px;">:</td><td style="width: calc(100% - 110px);">${ child.punishment_description }</td></tr><tr><td style="width: 100px; font-weight: 500;">Violation</td><td style="width: 10px;">:</td><td style="width: calc(100% - 110px);">${ child.violation_description }</td></tr></table>`
                      formatLoop['forValue3'] = formatDate('date', child.transaction_date)
                      formatLoop['forValue4'] = child.employee_name,
                      formatLoop['forState'] = 'green'
                      formatData.push(formatLoop)
                    }
                  }

                  punishmentPerfomanceFull.value = formatData
                  // console.log("cek loop child perfomance full", punishmentPerfomanceFull.value)
                }
                else if(value.id == 'relate_to_position') {
                  const formatData = []

                   if(value.list) {
                    for (const [list, child] of Object.entries(value.list)) {
                      const formatLoop = child
                      formatLoop['forId'] = child.id
                      formatLoop['forFormatDate'] = child.transaction_date
                      formatLoop['forValue1'] = child.number
                      formatLoop['forValue2'] = `<table style="width: 100%;"><tr><td style="width: 100px; font-weight: 500;">Punishment</td><td style="width: 10px;">:</td><td style="width: calc(100% - 110px);">${ child.punishment_description }</td></tr><tr><td style="width: 100px; font-weight: 500;">Violation</td><td style="width: 10px;">:</td><td style="width: calc(100% - 110px);">${ child.violation_description }</td></tr></table>`
                      formatLoop['forValue3'] = formatDate('date', child.transaction_date)
                      formatLoop['forValue4'] = child.employee_name,
                      formatLoop['forState'] = 'yellow'
                      formatData.push(formatLoop)
                    }
                  }

                  punishmentPositionFull.value = formatData
                  // console.log("cek loop child position full", punishmentPositionFull.value)
                }
                else if(value.id == 'is_terminated') {
                  const formatData = []

                   if(value.list) {
                    for (const [list, child] of Object.entries(value.list)) {
                      const formatLoop = child
                      formatLoop['forId'] = child.id
                      formatLoop['forFormatDate'] = child.transaction_date
                      formatLoop['forValue1'] = child.number
                      formatLoop['forValue2'] = `<table style="width: 100%;"><tr><td style="width: 100px; font-weight: 500;">Punishment</td><td style="width: 10px;">:</td><td style="width: calc(100% - 110px);">${ child.punishment_description }</td></tr><tr><td style="width: 100px; font-weight: 500;">Violation</td><td style="width: 10px;">:</td><td style="width: calc(100% - 110px);">${ child.violation_description }</td></tr></table>`
                      formatLoop['forValue3'] = formatDate('date', child.transaction_date)
                      formatLoop['forValue4'] = child.employee_name,
                      formatLoop['forState'] = 'red'
                      formatData.push(formatLoop)
                    }
                  }

                  punishmentTerminatedFull.value = formatData
                  // console.log("cek loop child terminated full", punishmentTerminatedFull.value)
                }
              }
            }

            isLoading.value = false
          }
        }
        catch(error) {
          console.log(error)
        }
      }


      const trainingBackData = ref([])
      const remainingAllData = ref([])
      const employeeBackData = ref([])
      const punishmentBackData = ref([])
      const refreshData = async () => {
        const headers = {'Content-Encoding': 'gzip'}
        const paramsEmployee = {
          user_id: localStorage.getItem('user_id'),
          branch_id: localStorage.getItem('branch_id'),
        }

        try {
          const [response1, response2, response3, response4] = await Promise.all([
            axios.get("employee-training", { headers }),
            axios.get("hrleave-employee", { headers }),
            axios.get("employee", { headers, params: paramsEmployee }),
            axios.get("punishment-transaction", { headers })
          ])

          if(response1.data.data) {
            trainingBackData.value = response1.data.data
            // console.log("cek back training", trainingBackData.value)
          }

          if(response2.data.data) {
            remainingAllData.value = response2.data.data
            // console.log("cek back leave", remainingAllData.value)
          }

          if(response3.data.data) {
            employeeBackData.value = response3.data.data
            // console.log("cek back employee", employeeBackData.value)
          }

          if(response4.data.data) {
            punishmentBackData.value = response4.data.data
            // console.log("cek back employee", punishmentBackData.value)
            isLoading.value = false
          }
        }
        catch(error) {
          console.log(error)
        }
      }


      const detailModal = ref(false)
      const modalType = ref(null)
      const detailData = ref({})
      const openDetail = (data, type) => {
        // console.log("cek base modal", data, type)
        if(data) {
          const prevData = data.data ? data.data : data ? data : {}
          const prevType = data.type ? data.type : type ? type : null

          modalType.value = (prevType ? prevType : null)
          // detailModal.value = true

          // console.log("cek type modal", prevType, prevData)

          if((prevType == 'training') && prevData && trainingBackData.value) {
            detailData.value = trainingBackData.value.filter(item => item.id == prevData.id)[0]
            detailModal.value = true
          }
          else if((prevType == 'leave') && prevData && remainingAllData.value) {
            detailData.value = remainingAllData.value.filter(item => item.id == prevData.id)[0]
            detailModal.value = true
          }
          else if(['decree', 'document', 'contract'].includes(prevType) && prevData && employeeBackData.value) {
            detailData.value = employeeBackData.value.filter(item => item.employee_id == (prevData.employee_id ? prevData.employee_id : prevData.id))[0]
            detailModal.value = true
          }
          else if((prevType == 'punishment') && prevData && punishmentBackData.value) {
            detailData.value = punishmentBackData.value.filter(item => item.id == prevData.id)[0]
            detailModal.value = true
          }
          else {
            detailModal.value = false
            modalType.value = null
            detailData.value = {}
          }

          // console.log("cek prev data detail", modalType.value, detailData.value)
        }else {
          detailModal.value = false
          modalType.value = null
          detailData.value = {}
        }
      }


      const totalChild = reactive({
        total: 0,
        state: false
      })
      const getSetData = async () => {
        const thisDate = new Date()
        let thisYear = thisDate.getFullYear()
        let thisMonth = ('0' + (thisDate.getMonth() + 1)).slice(-2)
        const monthNow = (thisYear + '-' + thisMonth)

        const headers = {'Content-Encoding': 'gzip'}

        const testParams1 = {
          user_id: userId.value,
          is_personal: 0,
          year: thisYear,
          month: thisMonth
        }

        try {
          const [response1] = await Promise.all([
            axios.get("get-leave-history", { headers, params: testParams1 })
          ])

          if(response1.data.data) {
            if(response1.data.data.length < 2) {
              const backData = response1.data.data[0]

              totalChild.total = backData.child_list.length
              totalChild.state = (totalChild.total != 0) ? true : false
            }
            else {
              totalChild.total = response1.data.data.length
              totalChild.state = (totalChild.total != 0) ? true : false
            }
          }
        }
        catch(error) {
          console.log(error)
        }
      }


      onBeforeMount(() => {
        getSetData()
        getData()
        refreshData()
      })


      onMounted(() => {

      })

      watchEffect(() => {

      })


      return {
        mdiClose,
        tabsList,
        tabActive,
        openTab,
        isLoading,
        employeeId,
        branchId,
        formatDate,
        modalDetail,
        objectDetail,
        openModal,
        trainingWaiting,
        trainingApprove,
        trainingReject,
        trainingWaitingFull,
        trainingApproveFull,
        trainingRejectFull,
        expiringDoc,
        expiredDoc,
        expiringLeave,
        expiredLeave,
        expiringContract,
        expiredContract,
        expiringDocFull,
        expiredDocFull,
        expiringLeaveFull,
        expiredLeaveFull,
        expiringContractFull,
        expiredContractFull,
        expiringCareer,
        expiredCareer,
        expiringCareerFull,
        expiredCareerFull,
        remainingAllData,
        employeeRetiring,
        employeeRetired,
        punishmentPayroll,
        punishmentPayrollFull,
        punishmentPerfomance,
        punishmentPerfomanceFull,
        punishmentPosition,
        punishmentPositionFull,
        punishmentTerminated,
        punishmentTerminatedFull,
        detailModal,
        modalType,
        detailData,
        openDetail,
        totalChild,
        refreshData,
        roles
      }
    }
  }
</script>
